import classNames from "classnames";
import { ReactComponent as VerifiedUser } from "../../assets/ic-verified-user.svg";

const VerifiedUserIcon = ({ isVisible, className }) => {
  return isVisible ? (
    <VerifiedUser
      className={classNames(className, "text-secondary-no-priority")}
    />
  ) : null;
};

export default VerifiedUserIcon;
